import { createContext } from "react";

export const InvestFormContext = createContext();

